import VALIDATION_RULES from './rules'

export { VALIDATION_RULES }

export * from './date'

export const ATTENDEES_PER_ROOM = 25
